import { Link } from "react-router-dom";

type Step = {
  key: string;
  label: string;
  href: string;
  done: number;
  total: number;
};

export function ProgressTracker({
  period,
  uploadsDone,
  uploadsTotal,
  reconsDone,
  reconsTotal,
  signaturesDone,
  signaturesTotal,
  binderLocked,
}: {
  period: string;
  uploadsDone: number;
  uploadsTotal: number;
  reconsDone: number;
  reconsTotal: number;
  signaturesDone: number;
  signaturesTotal: number;
  binderLocked: boolean;
}) {
  const steps: Step[] = [
    {
      key: "sources",
      label: "Source Files",
      href: `/close/${period}/sources`,
      done: uploadsDone,
      total: uploadsTotal,
    },
    {
      key: "recons",
      label: "Reconciliations",
      href: `/close/${period}`,
      done: reconsDone,
      total: reconsTotal,
    },
    {
      key: "signatures",
      label: "Signatures",
      href: `/close/${period}`,
      done: signaturesDone,
      total: signaturesTotal,
    },
    {
      key: "binder",
      label: "Close Binder",
      href: `/close/${period}`,
      done: binderLocked ? 1 : 0,
      total: 1,
    },
  ];

  return (
    <nav className="tracker">
      {steps.map((s, i) => {
        const complete = s.total > 0 && s.done === s.total;
        const started = s.done > 0;
        const state = complete ? "done" : started ? "active" : "pending";
        return (
          <Link key={s.key} to={s.href} className={`tracker-step ${state}`}>
            <div className="step-num">{i + 1}</div>
            <div className="step-body">
              <div className="step-label">{s.label}</div>
              <div className="step-meta">
                {s.done}/{s.total}
              </div>
            </div>
          </Link>
        );
      })}
    </nav>
  );
}
